export interface CodaConfig {
  host: string;
  src: string;
  theme: string;
  agentUrl: string;
}

export function getCodaConfig(): CodaConfig | null {
  const host = process.env.REACT_APP_CODA_HOST;
  const src = process.env.REACT_APP_CODA_SRC;

  if (!host || !src) {
    return null;
  }

  return {
    host,
    src,
    theme: process.env.REACT_APP_CODA_THEME || 'light',
    agentUrl: process.env.REACT_APP_CODA_AGENT_URL || '',
  };
}
